import { render, staticRenderFns } from "./ProductDesign.vue?vue&type=template&id=522de3e3&scoped=true"
import script from "./ProductDesign.vue?vue&type=script&lang=js"
export * from "./ProductDesign.vue?vue&type=script&lang=js"
import style0 from "./ProductDesign.vue?vue&type=style&index=0&id=522de3e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522de3e3",
  null
  
)

export default component.exports